/* import __COLOCATED_TEMPLATE__ from './upgrade-warning.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();